import React from 'react';
import { CnTag } from '../../../../components/cn-tag';
import './index.scss';
export const EntryPointsTags = (props) => {
    const { onItemClick, dataSource } = props;
    if (!dataSource?.length)
        return null;
    return (React.createElement("div", { className: "cn-entry-points-tags" }, dataSource.map((tag) => (React.createElement(CnTag, { key: tag.value, onClick: (event) => onItemClick?.(tag, event) }, tag.label)))));
};
